import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_EmergencyMedicalTreatment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_EmergencyMedicalTreatment' className='file-pdf-document'>
            <div className='file-template'>



                <p className='w-750'> <center> Authorization for Emergency Medical Treatment </center> </p>


                <p className='w-750'>
                    I, the recipient/guardian of <input type="text" name="txtTreatment" id="txtTreatment" className='add-only' />, subject to the conditions set forth below. I consent to receive such medical treatment and/or surgical procedures necessary in the event of an emergency and to assume liability for medical expenses involved. This authorization extends to my participation in any activity sponsores by Restore Outreach Center, as a whole, or by workers within each program site.
                </p>
                <p className='w-750'>
                    Should a medical emergency arise during my participation in a Restore Outreach sponsored event, I understand that reasonable efforts will be made to contact me or my designated emergency contact at the members listed below. If it is believed my life or health may be adversely affected by the delay that an attempt to contact or my designated contact could cause.
                </p>
                <p className='w-750'>
                    I consent to the administration of medical treatment and/or surgical procedures as deemed necessary by the medical doctor and/or facility and to the immediate administration of life-sustaining measure(s) deemed necessary under the circumstances.
                </p>
                <h4>
                    HEALTH INFORMATIONS:
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Doctor's name or Clinic</span>
                            <input type="text" name="txtClinic" id="txtClinic" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtDateBirthPhone" id="txtDateBirthPhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax:</span>
                            <input type="text" name="txtFax" id="txtFax" className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Allergies:</span>
                    <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                    <textarea id="txtAllergies1" name="txtAllergies1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Problems </span>
                    <span className='small'>(Diabetes, Epilepsy, etc ):</span>
                    <textarea id="txtAllergies2" name="txtAllergies2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have an Advanced Directive? If yes, please provide Restore Outreach with a copy?</span>
                    <input type="radio" id="rbAdvanced_Yes" name="rbAdvanced" className='add-only' value="1" />Yes
                    <input type="radio" id="rbAdvanced_No" name="rbAdvanced" className='add-only' value="0" />No
                    <textarea id="txtAdvanced" name="txtAdvanced" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any communication barries which may make it difficult to understand him/her?</span>
                    <input type="radio" id="rbAdvanced1_Yes" name="rbAdvanced" className='add-only' value="1" />Yes
                    <input type="radio" id="rbAdvanced1_No" name="rbAdvanced1" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id="txtAdvanced1" name="txtAdvanced1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have a history of Substance Abuse?</span>
                    <input type="radio" id="rbAdvanced2_Yes" name="rbAdvanced2" className='add-only' value="1" />Yes
                    <input type="radio" id="rbAdvanced2_No" name="rbAdvanced2" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id="txtAdvanced2" name="txtAdvanced2" className='add-only'></textarea>
                </p>
                <h4>
                    INSURANCE INFORMATION:
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Company:</span>
                            <input type="text" name="txtCompany" id="txtCompany" className='add-only' />
                        </td>
                        <td className='w-150' >
                            <span className='eleHeader'>Policy#:</span>
                            <input type="text" name="txtPolicy" id="txtPolicy" className='add-only' />
                        </td>
                        <td className='w-350' >
                            <span className='eleHeader'>Policy Holders Name and Relationship to Child:</span>
                            <input type="text" name="txtPolicyHolders" id="txtPolicyHolders" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    CONTACT INFORMATION:
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Recipient Name:</span>
                            <input type="text" name="txtRecipientName" id="txtRecipientName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Parent/Guardian Name:</span>
                            <input type="text" name="txtGuardianName" id="txtGuardianName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                            <input type="text" name="txtAddress" id="txtAddress" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Phone #:</span>
                            <input type="text" name="txtHomePhone" id="txtHomePhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Alternative Phone#:</span>
                            <input type="text" name="txtAlternativePhone" id="txtAlternativePhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Emergency Contact Person:</span>
                            <input type="text" name="txtEmergencyContact" id="txtEmergencyContact" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                            <input type="text" name="txtRelationship3" id="txtRelationship3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                            <input type="text" name="txtAlternativeAddress" id="txtAlternativeAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Phone:</span>
                            <input type="text" name="txtEmerHomePhone" id="txtEmerHomePhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Alternative Phone:</span>
                            <input type="text" name="txtRelationshipAlternative" id="txtRelationshipAlternative" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Preferred Doctor/Medical Facility:</span>
                            <input type="text" name="txtPreferredDoctor" id="txtPreferredDoctor" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtEmerHomePhone1" id="txtEmerHomePhone1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500 signature'> &nbsp; </td>
                        <td className='w-250 signature'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small'>
                            Signature of Recipient/Parent or Guardian:
                        </td>
                        <td className='small'>
                            Date:
                        </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}